// Mirrors Models/Currency.cs on the server. Extending this list requires
// adding the matching ISO 4217 code to Models.Currency.Supported so the
// Customer / Job controllers accept it on write.
//
// `symbol` is used for react-countup `prefix` in KPI tiles where the full
// Intl.NumberFormat output isn't a good fit; everywhere else prefer
// formatCurrency(value, code) from utils/formatters.
export const CURRENCIES = [
    { code: 'GBP', symbol: '£', name: 'Pound sterling' },
    { code: 'EUR', symbol: '€', name: 'Euro'           },
    { code: 'USD', symbol: '$', name: 'US dollar'      },
];

export const DEFAULT_CURRENCY = 'GBP';

export function currencySymbol(code) {
    return CURRENCIES.find((c) => c.code === code)?.symbol ?? '';
}
